import React from 'react';

import styled from '@emotion/styled';

import COLOR from '../../../../../shared/constant/colorset';

const Container = styled.div`
  margin-right: 18px;
`;

const Description = styled.div`
  padding: 14px 0;
`;

const SkeletonItem = styled.div`
  background-color: ${COLOR.kurlyGray200};
`;

const Thumbnail = styled(SkeletonItem)`
  width: 249px;
  height: 320px;
`;

const TextLine = styled(SkeletonItem)`
  width: 124px;
  height: 23px;
  margin-top: 8px;
  &:first-of-type {
    margin-top: 0;
  }
`;

const ProductCardSkeleton = () => {
  return (
    <Container>
      <Thumbnail />
      <Description>
        <TextLine />
        <TextLine />
        <TextLine />
      </Description>
    </Container>
  );
};

export default ProductCardSkeleton;
